module.exports = __webpack_public_path__ + "946abfbf20bfaae313f815e160923b82.png";